<script>
/**
 * ****************************************************************************
 * @description     :   Component for show error in Header
 * @created at      :   2024/05/22
 * @created by      :   ANS903 – phuongdt@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import libraries
 */
import { mapState, mapMutations } from 'vuex';
import { MSG_TYPE, MSG_BUTTON } from '@/utils/messages';

/**
 * Import template
 */
import template from './template.html';
import helpers from '@/utils/helpers';

/**
 * Define component chat for show page chat
 */
var HeaderError = {
    template: template,
    data() {
        return {
            havePopup: false
        };
    },
    methods: {
        ...mapMutations('app', ['hideHeaderError', 'showModalMessage']),
        hideError() {
            this.hideHeaderError();
            helpers.clearAllRequireInput();
        }
    },
    watch: {
        isShowHeaderError() {
            // if (newVal) {
            //     const collection =
            //         document.getElementsByClassName('modal show');
            //     if (collection.length > 0) {
            //         this.havePopup = true;
            //     } else {
            //         this.havePopup = false;
            //     }
            // } else {
            //     this.havePopup = false;
            // }
            if (this.headerErrors.length) {
                this.showModalMessage({
                    type: MSG_TYPE.ERROR,
                    title: 'エラー',
                    content: this.headerErrors[0],
                    okText: MSG_BUTTON.okText
                });
            }
        }
    },
    computed: {
        ...mapState('app', ['isShowHeaderError', 'headerErrors', 'isMobile'])
    }
};
export default HeaderError;
</script>
